var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sessions-page"},[(_vm.sessions)?_c('SessionsTable',{attrs:{"sessions":_vm.sessions,"forms":_vm.forms},on:{"set-session":_vm.setSessionId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }